module.exports = __webpack_public_path__ + "img/d.1307de13.jpg";